// @flow
export { default } from './BannerPlaceholder';



// WEBPACK FOOTER //
// ./src/components/banner/BannerPlaceholder/index.js